module.exports = __webpack_public_path__ + "img/Logo_principal.c5ea736a.svg";